import React, { FC } from "react";
import cn from "classnames";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { Link } from "src/components/Link";
import { PATHNAMES } from "src/constants/routes";
import {
  CORNER_ELEMENT_AFTER,
  CORNER_ELEMENT_BEFORE,
} from "src/constants/cornerElement";
import { ReactComponent as ArrowGreenIcon } from "src/assets/icons/arrow-right-green-dark.svg";
import { ReactComponent as ArrowWhiteIcon } from "src/assets/icons/arrow-right-white-base.svg";
import { Theme } from "src/@types/blog";
import { IBlogCard } from "./types";

const ICON_SIZE = 30;

interface Props extends Pick<IBlogCard, "id" | "theme"> {}

export const NextButton: FC<Props> = ({ theme = Theme.LIGHT, id }) => {
  const blogItemPath = PATHNAMES.BLOG_ITEM(String(id));

  return (
    <Link
      href={blogItemPath}
      className={cn(
        "absolute -bottom-2 -right-2 lg:-bottom-4 lg:-right-4 z-10 bg-white-base p-2 lg:p-4 rounded-tl-2xl rounded-bl-2xl",
        CORNER_ELEMENT_BEFORE,
        "before:right-2 before:-top-6.25 lg:before:right-4 before:shadow-corner-white-base",
        CORNER_ELEMENT_AFTER,
        "after:top-[33px] lg:after:top-[53px] after:-left-6.25 after:shadow-corner-white-base",
      )}
    >
      <Button
        variant={ButtonVariants.LIGHT_BLUE}
        className={cn("max-w-12.5 max-h-12.5 lg:max-w-full lg:max-h-full", {
          "!bg-green-dark": theme === Theme.DARK,
        })}
      >
        {theme === Theme.DARK ? (
          <ArrowWhiteIcon
            className="flex-shrink-0 hover:translate-x-5"
            width={ICON_SIZE}
            height={ICON_SIZE}
          />
        ) : (
          <ArrowGreenIcon
            className="flex-shrink-0 hover:translate-x-5"
            width={ICON_SIZE}
            height={ICON_SIZE}
          />
        )}
      </Button>
    </Link>
  );
};
